import { render, staticRenderFns } from "./organizations-dropdown.vue?vue&type=template&id=33049b15&scoped=true&"
import script from "./organizations-dropdown.vue?vue&type=script&lang=ts&"
export * from "./organizations-dropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33049b15",
  null
  
)

export default component.exports